import React from 'react';
import PropTypes from 'prop-types';
import getHostDomain from 'helpers/getHostDomain';

import PasswordTextField from 'components/PasswordTextField/PasswordTextField';
import SplitPageContainer from 'components/SplitPageContainer';
import SplitPageRight from 'components/SplitPageRight';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    header: {
      fontSize: 50,
      lineHeight: 1,
      color: theme.palette.primary.main,
      marginTop: theme.spacing(13),
      [theme.breakpoints.down('xs')]: {
        fontSize: 30,
        marginTop: theme.spacing(5),
      },
    },
    subheader: {
      maxWidth: theme.spacing(65),
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(4),
      },
    },
    button: {
      fontWeight: 'bold',
      fontSize: 14.6,
      lineHeight: 1.1,
      letterSpacing: 1.3,
      width: 243,
      marginTop: theme.spacing(8),
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(2),
      },
    },
    input: {
      marginTop: theme.spacing(6),
      width: '100%',
      minHeight: 70,
    },
    labelSize: {
      fontSize: 25,
      paddingTop: theme.spacing(1),
    },
    inputSize: {
      fontSize: 28,
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
      },
    },
    disabled: {
      borderColor: theme.palette.grey[300],
    },
    textfield: {
      width: '60%',
      [theme.breakpoints.down('xs')]: {
        width: '90%',
      },
    },
  };
};

class CreateYourPassword extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    setPassword: PropTypes.func.isRequired,
    password: PropTypes.string,
    passwordConfirmed: PropTypes.func.isRequired,
    email: PropTypes.string,
    submitPasswordInviteToken: PropTypes.func.isRequired,
    inviteToken: PropTypes.string.isRequired,
    subdomain: PropTypes.string.isRequired,
    isTrial: PropTypes.bool.isRequired,
  };

  state = {
    buttonLocked: null,
    validPassword: false,
  };

  handleSubmit = event => {
    if (this.unlockButton()) {
      this.submitPassword();
    }
    event.preventDefault();
  };

  setPasswordConfirmation = validPassword => {
    this.setState({ validPassword: validPassword });
  };

  setPassword = password => {
    this.props.setPassword(password);
  };

  toggleButton = datafromChild => {
    this.setState({ buttonLocked: datafromChild });
  };

  submitPassword = async () => {
    await this.props.submitPasswordInviteToken(
      this.props.inviteToken,
      this.props.password,
      this.props.subdomain,
    );

    if (!this.props.isTrial) {
      const hostDomain = getHostDomain();
      window.location.href = `https://app.${hostDomain}.com/`;
    }

    this.props.passwordConfirmed(true);
  };

  unlockButton = () => {
    return (
      /[a-z]/.test(this.props.password) &&
      /[A-Z]/.test(this.props.password) &&
      /.{8,}/g.test(this.props.password) &&
      /[0-9]/.test(this.props.password)
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <SplitPageContainer>
        <SplitPageRight>
          <Typography className={classes.header} variant="h2">
            Create Your Password
          </Typography>
          <Typography className={classes.subheader} variant="body1">
            Enter a new password. Passwords must be at least 8 characters, include one lowercase,
            one uppercase, and one number.
          </Typography>
          <div className={classes.textfield}>
            <FormControl className={classes.input}>
              <InputLabel className={classes.labelSize}>
                {/* more height with top label */}
                Email
              </InputLabel>
              <Input className={classes.inputSize} value={this.props.email} disabled />
            </FormControl>
            <form onSubmit={this.handleSubmit}>
              <PasswordTextField
                passwordCallback={this.setPassword}
                password={this.props.password}
                validPasswordCallback={this.setPasswordConfirmation}
                label="New Password"
              />
            </form>
          </div>
          <div>
            <Button
              className={classes.button}
              disabled={!this.state.validPassword}
              classes={{ disabled: classes.disabled }}
              color="secondary"
              variant="outlined"
              onClick={this.submitPassword}
              type="submit"
            >
              Create your Password
            </Button>
          </div>
        </SplitPageRight>
      </SplitPageContainer>
    );
  }
}

export default withStyles(styles)(CreateYourPassword);
